<template>
  <modal v-if="modalExitAll" v-model:show="showModal" :showClose="false" :clickClose="false">
    <template v-slot:header>
      <h5 class="modal-title">You are about to exit all the positions for the users {{ currentUser?.name }} </h5>
    </template>
    <form id="my-form">
      <div class="">
        <label for="recipient-name" class="text-black text-xs font-weight-bold text-capitalize">Users:</label>
        <base-input name="selectmultiple" class="w-100 mr-2">
          <el-select v-model="tempUserIds" multiple filterable :collapse-tags="shouldCollapseTags"
            placeholder="Select Users" @change="handleSelectAll('user', $event)">
            <el-option :key="'select_all'" :label="getSelectAllLabel('user')" value="select_all"></el-option>
            <el-option v-for="option in sortedSelectOptions" :key="option.key" :label="option.value"
              :value="option.key">
            </el-option>
          </el-select>
        </base-input>
      </div>
      <div>
        <label for="recipient-name" class="text-black text-xs font-weight-bold text-capitalize">Instruments:</label>
        <base-input name="selectmultiple" class="w-100   mr-2">
          <el-select v-model="tempInstruments" multiple filterable :collapse-tags="shouldCollapseTagsInstruments"
            placeholder="Select Instruments" @change="handleSelectAll('instrument', $event)">
            <el-option :key="'select_all_instruments'" :label="getSelectAllLabel('instrument')"
              value="select_all_instruments"></el-option>
            <el-option v-for="option in sortedInstrumentsOptions" :key="option.key" :label="option.value"
              :value="option.key">
            </el-option>
          </el-select>
        </base-input>
      </div>
      <div>
        <label for="recipient-name" class="text-black text-xs font-weight-bold text-capitalize">TradeTerm:</label>
        <base-input name="selectmultiple" class="w-100   mr-2">
          <el-select class="w-100 ml-2 mr-2 pagination-select" v-model="selectedTradeTerm"
            placeholder="Select TradeTerm" @change="handlePerPageChange">
            <el-option class="select-primary" v-for="item in tradeTerms" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </base-input>
      </div>
      <div class="mt-2">
        <el-checkbox v-model="updatePnlReference">
          <span class="text-danger font-weight-bold">Update PnL Reference</span>
        </el-checkbox>
      </div>
    </form>
    <div class="mt-4 d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" @click="closeModal()">Close</button>
      <button class="btn btn-primary" type="button" @click="exitAll()">Exit All</button>
    </div>
    <div v-if="errorFlag" class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ errorMessage }}</small>
    </div>
  </modal>
  <modal v-model:show="showVerifyModal" :showClose="false" :clickClose="false">
    <form>
      <div class="mb-3">
        <h1 class="display-1 mb-0 text-center text-primary">{{ randomNum }}</h1>
      </div>
      <div class="mb-3">
        <label for="user-input"
          class="text-black text-sm d-flex justify-content-center align-item-center font-weight-bold text-capitalize">
          please enter the provided number:
        </label>
        <input type="text" v-model="userInput" class="form-control d-flex justify-content-center align-item-center"
          id="user-input" maxlength="3" placeholder="Enter 3-digit number" />
      </div>
    </form>
    <div class="mt-4 d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" @click="goToPrevious()">Edit</button>
      <button class="btn btn-primary" type="button" @click="validateInput();">Verify</button>
    </div>
    <div class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ validationMessage }}</small>
    </div>
    <div v-if="errorFlag" class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ errorMessage }}</small>
    </div>
  </modal>
</template>
<script>
import {
  ElSelect,
  ElOption,
  ElInput,
  ElCheckbox,
} from "element-plus";
import Modal from "@/components/Modal";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default {
  name: "ExitAll",
  components: {
    Modal,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElInput.name]: ElInput,
    [ElCheckbox.name]: ElCheckbox,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    modalExitAll: {
      type: Boolean,
      default: false,
    },
    currentUser: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      errorFlag: false,
      tempUserIds: [],
      tempInstruments: [],
      selectOptions: [],
      instrumentOptions: [],
      showVerifyModal: false,
      randomNum: '',
      userInput: "",
      validationMessage: "",
      tradeTerms: ["OVERNIGHT", "INTRADAY"],
      selectedTradeTerm: "",
      updatePnlReference: false,
    };
  },
  computed: {
    shouldCollapseTags() {
      const allUserIds = this.selectOptions.map(option => option.key);
      return this.tempUserIds.length > 10 || this.tempUserIds.length === allUserIds.length;
    },
    sortedSelectOptions() {
      return [...this.selectOptions].sort((a, b) => {
        const isASelected = this.tempUserIds.includes(a.key);
        const isBSelected = this.tempUserIds.includes(b.key);
        if (isASelected === isBSelected) {
          return a.value.localeCompare(b.value);
        }
        return isASelected ? -1 : 1;
      });
    },
    shouldCollapseTagsBrokers() {
      const totalBrokers = this.brokerOptions.length;
      const isSelectAll = this.tempBrokers.length === totalBrokers;
      return isSelectAll && totalBrokers > 10;
    },
    sortedInstrumentsOptions() {
      return [...this.instrumentOptions].sort((a, b) => {
        const isASelected = this.tempInstruments.includes(a.key);
        const isBSelected = this.tempInstruments.includes(b.key);
        if (isASelected === isBSelected) {
          return a.value.localeCompare(b.value);
        }
        return isASelected ? -1 : 1;
      });
    }
  },
  methods: {
    getSelectAllLabel(type) {
      if (type === 'user') {
        const allUserIds = this.selectOptions.map(option => option.key);
        return this.tempUserIds.length === allUserIds.length ? 'Deselect All Users' : 'Select All Users';
      } else if (type === 'instrument') {
        const allInstruments = this.instrumentOptions.map(option => option.key);
        return this.tempInstruments.length === allInstruments.length ? 'Deselect All Instruments' : 'Select All Instruments';
      }
    },
    handleSelectAll(type, value) {
      let options = type === 'user' ? this.selectOptions : this.instrumentOptions;
      let tempList = type === 'user' ? this.tempUserIds : this.tempInstruments;
      const selectAllKey = type === 'user' ? 'select_all' : 'select_all_instruments';
      const allKeys = options.map(option => option.key);
      if (value.includes(selectAllKey)) {
        if (tempList.length === allKeys.length + 1) {
          type === 'user' ? this.tempUserIds = [] : this.tempInstruments = [];
        } else {
          type === 'user' ? this.tempUserIds = [...allKeys] : this.tempInstruments = [...allKeys];
        }
      } else {
        if (tempList.includes(selectAllKey)) {
          type === 'user'
            ? this.tempUserIds = this.tempUserIds.filter(v => v !== selectAllKey)
            : this.tempInstruments = this.tempInstruments.filter(v => v !== selectAllKey);
        }
      }
    },
    closeModal() {
      this.errorFlag = false;
      this.tempUserIds = [];
      this.tempInstruments = [];
      this.check = false;
      this.validationMessage = "";
      this.userInput = "";
      this.updatePnlReference = false;
      this.$emit('updateParameters', false, false);
    },
    getRandomNumber() {
      this.randomNum = Math.floor(100 + Math.random() * 900);
    },
    exitAll() {
      this.getRandomNumber();
      this.$emit("updateParameters", false, this.modalExitAll);
      this.showVerifyModal = true;
    },
    goToPrevious() {
      this.showVerifyModal = false;
      this.$emit("updateParameters", true, this.modalExitAll);
    },
    validateInput() {
      if (parseInt(this.userInput) === this.randomNum) {
        this.validationMessage = "";
        this.endAllOrders();
      } else {
        this.errorFlag = false;
        this.validationMessage = "Incorrect number. Please try again.";
      }
    },
    async endAllOrders() {
      var self = this;
      let data = {
        "otp": "123",
        "userIds": self.tempUserIds,
        "exchangeTokens": self.tempInstruments,
        "tradeTerm": self.selectedTradeTerm,
        "isPnlRefUpdate": self.updatePnlReference
      }
      self.$store
        .dispatch("settingStore/squareOff", data, { root: true })
        .then(function (response) {
          self.showVerifyModal = false;
          self.$emit('updateParameters', false, false);
          swal.fire({
            title: "Square Off!",
            text: "Request to square off the positions are placed.",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
            },
            icon: "success",
          });
          self.tempUserIds = [];
          self.tempInstruments = [];
          self.selectedTradeTerm = "";
          self.updatePnlReference = false;
          self.check = false;
        }).catch(function (error) {
          self.errorFlag = true;
          self.errorMessage = error.server.response.data.message;
        });
    },
    getActiveUsers() {
      let data = {
        type: 'active-users'
      };
      if (sessionStorage.getItem(data.type + "-reference-data")) {
        this.selectOptions = JSON.parse(sessionStorage.getItem(data.type + "-reference-data"))
      } else {
        this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
          .then(response => {
            this.selectOptions = response.server.data;
            sessionStorage.setItem(data.type + "-reference-data", JSON.stringify(this.selectOptions));
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    getActiveInstruments() {
      let data = {
        type: 'active-instruments'
      };
      this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
        .then(response => {
          this.instrumentOptions = response.server.data;
          sessionStorage.setItem(data.type + "-reference-data", JSON.stringify(this.instrumentOptions));
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getActiveUsers();
    this.getActiveInstruments();
  }
};
</script>
